import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconSearchSideBar({
  fill = 'var(--sapphire-20)',
  width = 18,
  height = 18,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 9V2C17 1.44772 16.5523 1 16 1H2C1.44772 1 1 1.44772 1 2V12C1 12.5523 1.44772 13 2 13H5M3 3H13M3 5H7M17 17L13.5 13.5M15 10.5C15 12.9853 12.9853 15 10.5 15C8.01472 15 6 12.9853 6 10.5C6 8.01472 8.01472 6 10.5 6C12.9853 6 15 8.01472 15 10.5Z" stroke={fill} strokeWidth="1.25"/>
    </svg> 
  );
}
